import React,{useEffect,useState,useRef} from "react";
import { data, useNavigate, useParams } from "react-router-dom";
import { getValue } from '@syncfusion/ej2-base';
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  ColumnChooser,
  Resize,
  Sort,
  ContextMenu,
  Filter,
  Page,
  ExcelExport,
  PdfExport,
  Edit,
  Inject,
  Toolbar,
  ToolbarItems ,
  enableToolbarItems,
} from "@syncfusion/ej2-react-grids";
import { DialogComponent,DialogUtility } from '@syncfusion/ej2-react-popups';
import { DropDownListComponent  } from '@syncfusion/ej2-react-dropdowns';
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { DateRangePickerComponent  } from '@syncfusion/ej2-react-calendars';

import { 
  getReports,reportsGrid, getTillReports,reportsGridTill,GetReportsToPi
        } from "../data/reports";

        import moment from "moment";

import { Header } from "../components";
import { useStateContext } from "../contexts/ContextProvider";
import { toCurrency } from "../tools/currency";
import { ShowToast} from "../tools/extras";
import { ReportDetail } from ".";

const Reports = () => {
  const gridcomp = useRef();
  const gridcompTill = useRef();
  const drPicker = useRef();

  const {currentMode} = useStateContext();
  const [reports, setReports] = useState([]);
  const [reportsBack, setBackReports] = useState([]);
  const navigate = useNavigate();
  const [visibilityTillReport, setvisibilityTillReport] = useState(false);
  const [TillReports, setTillReports] = useState([]);

  const [selectedProduct, setSelectedProduct] = useState([]);

  const eSettings = {allowEditOnDblClick: false};
  const sSettings = { type: 'Multiple', mode: 'Row',enableSimpleMultiRowSelection: true};  

 


  const [info, setInfo] = useState({Total:0,Vat:0,WVat:0,NVat:0,Card:0,Cash:0});
  
  const bgcolor = currentMode === "Dark" ? "bg-gray-700" : "bg-white";

  //const toolbarOptions = ['Edit', 'Delete', 'Update', 'Cancel','Search']; toolbar={toolbarOptions}
 
  const rowSelected = (args) => {  
    //alert(args.data.UserName)
    setSelectedProduct(args.data);
  }
  const [SelectedReports, setSelectedReports] = useState(0);

  const gridLoad =() => {
    getReports ((data) => {
      setReports(data); 
      setBackReports(data); 
    });

  }
  

  useEffect(() => { 
    gridLoad();
    
    gridcompTill.current.refresh();
    var btnGetAllReports = document.getElementById('getAllReports')
    if(btnGetAllReports!==undefined && btnGetAllReports.getAttribute('listener') !== 'true') {
      btnGetAllReports.addEventListener('click',()=>{
        var selectedRecords = gridcompTill.current.dataSource.map((item) => {
          return item.IID;
        });
        //console.log(selectedRecords);return;
        if(selectedRecords.length === 0) {
          ShowToast({title:'Select Reports', content:'There is No Reports on the Till',type:'warning'});
          return;
        }
        GetReportsToPi(selectedRecords,(data)=>{          
          if(data.success === true){
              ShowToast({title:'Reports', content:'Reports Received from',type:'success'});
              setvisibilityTillReport(false);
              gridLoad();
          }else{
            ShowToast({title:'Reports', content:'Failed to send reports',type:'error'});
          }
        });
      });
      btnGetAllReports.setAttribute('listener', 'true');
    }
    var btnSelectedReports = document.getElementById('getSelectedReports')
    if(btnSelectedReports!==undefined && btnSelectedReports.getAttribute('listener') !== 'true') {
      btnSelectedReports.addEventListener('click',()=>{
        var selectedRecords = gridcompTill.current.getSelectedRecords().map((item) => {
          return item.IID;
        });
        if(selectedRecords.length === 0) {
          ShowToast({title:'Select Reports', content:'Please select reports to send',type:'warning'});
          return;
        }
        GetReportsToPi(selectedRecords,(data)=>{        
          if(data.success === true){
            ShowToast({title:'Reports', content:'Selected Reports Received from the Till',type:'success'});
            setvisibilityTillReport(false);
            gridLoad();
            }else{
            ShowToast({title:'Reports', content:'Failed to send selected reports',type:'error'});
          }
        });
      });
      btnSelectedReports.setAttribute('listener', 'true');
    }

    


  },[TillReports,gridcompTill]);


  const ReportDetail = () => {
    if (selectedProduct.IID !== undefined) 
      navigate('/reports/' + selectedProduct.IID);
    else
      ShowToast({title:'Select Report', content:'Please select a report to view details',type:'warning'});
    
      
  }

  const GetOldReports = () => {
    setvisibilityTillReport(true);

    getTillReports((data) => {
      setTillReports(data);
      
    });
  }
  const SendReports = () => {
    
  }
  const DeleteReport = () => {
    
  }
  const FilterReport = () => {
    var enddate =  moment(drPicker.current.modelValue[1]);
    var startdate =  moment(drPicker.current.modelValue[0]);
    //console.log(startdate.isValid(),enddate.isValid());    
    if(startdate.isValid() == false || enddate.isValid() == false) {
      setReports(reportsBack);
    }else{
      var t = reportsBack.filter(x => {
        const xDate = moment(x.StartDate);        
        return xDate.isSameOrAfter(startdate, 'day') && xDate.isSameOrBefore(enddate, 'day');
      });
      //console.log(t,reportsBack);
      setReports(t);
    }    
  }

  const toolbarClick = (args) => {
    if (args.item.id === 'gridcomp_excelexport') {
      gridcomp.current.excelExport();
    } 
  }
  const toolbarOptions = ['ExcelExport', 'ColumnChooser'];
  const toolbar = toolbarOptions.map((item) => {
    return { text: item, id: 'gridcomp_' + item.toLowerCase(), Disable: false };
  });

  const dialogClose = ()=> {
    setvisibilityTillReport(false);
    //setDialogVisibilityOrders(false);
    //setDialogVisibilityOrder(false);
  }
  
  return (
    <div className={"mx-5 rounded-2xl " + bgcolor} >
      <Header title="Reports" />   
      <div className="grid grid-cols-5 gap-2">       
        <div className="col-span-5">
        <div className="e-btn-group grid grid-cols-2 lg:grid-cols-4">          
        </div>       
        <div className="e-btn-group grid grid-cols-2 lg:grid-cols-4">
          <button onClick={ReportDetail}
              className="e-btn bg-indigo-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
          >Report Details</button>  
          <button onClick={GetOldReports}
              className="e-btn bg-yellow-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
          >Get Old Reports</button>
          <button onClick={SendReports}
              className="e-btn bg-violet-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
          >Send Report</button> 
          <button onClick={DeleteReport}
              className="e-btn bg-rose-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
          >Delete Report</button>   
        </div>
      </div>      
      <div className="col-span-5 grid grid-cols-2 gap-0.5">
        <DateRangePickerComponent id="drPicker" ref={drPicker} placeholder='Select a range' format='dd-MM-yyyy' />
         <button onClick={FilterReport}
              className="e-btn bg-green-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
          >Filter by Date</button>  
      </div>
    </div>  
      
      <GridComponent id="gridcomp" ref={gridcomp} allowPaging allowSorting  load={gridLoad}
                      dataSource={reports} rowSelected={rowSelected} selectionSettings={sSettings}
                      sortSettings={ {columns: [{field: 'StartDate', direction: 'Descending'}]}} >
        <ColumnsDirective>
          {reportsGrid.map((item, index) => (
            <ColumnDirective key={index} {...item}  />
          ))}
        </ColumnsDirective>
        <Inject services={[Resize, Sort, ContextMenu, Filter, Page, ExcelExport, Edit, PdfExport,Toolbar,ColumnChooser]} />
      </GridComponent>


    <DialogComponent isModal={true}  id="modalDetails" showCloseIcon={true} visible={visibilityTillReport} close={dialogClose} header="Get Reports From Till" 
      cssClass="e-fixed border-8 border-zing-500" width='600px' >
        <div >
          <div className="grid grid-cols-2 gap-2">
            <button id="getAllReports" 
                className="e-btn bg-sky-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
                >Get All Reports</button>
                <button id="getSelectedReports" 
                className="e-btn bg-sky-300 hover:bg-indigo-200 shadow-primary-1 p-2 font-medium uppercase rounded" 
                >Get Selected Reports</button>
              <div className="col-span-4 lg:col-span-1">
                <div id="orderitemtotal" className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md"></div> 
                <div id="orderitemvat" className="e-label text-sm text-right bg-zinc-50 pr-2 drop-shadow-md"></div> 
            </div>
          </div>
          <GridComponent id="gridcompTill" ref={gridcompTill} 
          allowPaging allowSorting  dataSource={TillReports} editSettings={eSettings} selectionSettings={sSettings}>
            <ColumnsDirective>
              {reportsGridTill.map((item, index) => (
                <ColumnDirective key={index} {...item}  />
              ))}
        </ColumnsDirective>
        <Inject services={[Resize, Sort, ContextMenu, Filter, Page, ExcelExport, Edit, PdfExport,Toolbar]} />
      </GridComponent>
        </div>
    </DialogComponent>      
      

     
    </div>
  );
};

export default Reports;
